import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Button } from '@wordpress/components';
import { RawHTML } from '@wordpress/element';
import { safeHTML } from '@wordpress/dom';
export default function BlockView(_ref) {
  let {
    title,
    rawContent,
    renderedContent,
    action,
    actionText,
    className
  } = _ref;
  return createElement("div", {
    className: className
  }, createElement("div", {
    className: "block-editor-block-compare__content"
  }, createElement("h2", {
    className: "block-editor-block-compare__heading"
  }, title), createElement("div", {
    className: "block-editor-block-compare__html"
  }, rawContent), createElement("div", {
    className: "block-editor-block-compare__preview edit-post-visual-editor"
  }, createElement(RawHTML, null, safeHTML(renderedContent)))), createElement("div", {
    className: "block-editor-block-compare__action"
  }, createElement(Button, {
    variant: "secondary",
    tabIndex: "0",
    onClick: action
  }, actionText)));
}
//# sourceMappingURL=block-view.js.map